import React from 'react';
import { Tag } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import RowActions from '../../Shared/RowActions/RowActions';
import { format } from 'date-fns';

export const TABLE_CLASS = 'transactions-table';
export const ROW_CLASS_DISABLED = `${TABLE_CLASS}__row--disabled`;
export const ROW_CLASS_HIGHLIGHT = `${TABLE_CLASS}__row--highlight`;

export const formatDate = (dateString) => {
    return dateString ? format(new Date(dateString), 'yyyy-MM-dd HH:mm') : '';
};

export const getRowClassName = (record, highlightedRowIds) => {
    const classes = [];
    if (record?.is_disabled) classes.push(ROW_CLASS_DISABLED);
    if (highlightedRowIds?.has?.(record?.id)) classes.push(ROW_CLASS_HIGHLIGHT);
    return classes.join(' ');
};

export const getColumns = (t, user, screens, onAction) => [
    {
        title: t('id'),
        dataIndex: "id",
        key: "id",
        sorter: true,
    },
    ...(user?.is_admin ? [{
        title: t('user'),
        dataIndex: "user",
        key: "user",
        sorter: true,
        render: (user) => (
            user?.full_name
        ),
    }] : []),
    {
        title: t('transaction_type'),
        dataIndex: "transaction_type",
        key: "transaction_type",
        sorter: true,
        render: (type) => {
            const label = typeof type === 'string'
                ? t(type, { defaultValue: type })
                : '';
            return (
                <Tag color={type === "payment" ? "green" : type === "refund" ? "red" : "blue"}>
                    {label}
                </Tag>
            );
        }
    },
    {
        title: t('transaction_status'),
        dataIndex: "transaction_status",
        key: "transaction_status",
        sorter: true,
        render: (status) => {
            const label = typeof status === 'string'
                ? t(status, { defaultValue: status })
                : '';
            let color;
            switch (status) {
                case "completed":
                    color = "success";
                    break;
                case "pending":
                    color = "warning";
                    break;
                case "cancelled":
                    color = "error";
                    break;
                case "disabled":
                    color = "default";
                    break;
                default:
                    color = "default";
            }
            return <Tag color={color}>{label}</Tag>;
        }
    },
    {
        title: t('coins_amount'),
        dataIndex: "coins_amount",
        key: "coins_amount",
        sorter: true,
        render: (amount) => {
            const isPositive = amount > 0;
            return (
                <span style={{ color: isPositive ? "green" : "red" }}>
                    {amount}
                </span>
            );
        }
    },
    {
        title: t('description'),
        dataIndex: "description",
        key: "description",
        sorter: true,
    },
    {
        title: t('cancellation_reason'),
        dataIndex: "cancellation_reason",
        key: "cancellation_reason",
        sorter: true,
    },
    {
        title: t('created_at'),
        dataIndex: "created_at",
        key: "created_at",
        sorter: true,
        render: (date) => formatDate(date),
    },
    {
        title: t('disabling_reason'),
        dataIndex: "disabling_reason",
        key: "disabling_reason",
        sorter: true,
    },
    {
        title: t('actions'),
        key: "actions",
        render: (text, record) => (
            <RowActions
                screens={screens}
                primary={{
                    label: t('view_details'),
                    icon: <FileTextOutlined />,
                    onClick: () => onAction('view', record),
                    tooltip: t('view_details')
                }}
                items={[
                    ...(user?.is_admin && record.transaction_type === 'payment' ? [{
                        key: 'reconcile',
                        label: t('reconcile_transaction'),
                        icon: <FileTextOutlined />,
                        onClick: () => onAction('reconcile', record)
                    }] : []),
                    ...(user?.is_admin ? [
                        record?.is_disabled ? {
                            key: 'enable',
                            label: t('enable_transaction'),
                            icon: <FileTextOutlined />,
                            onClick: () => onAction('enable', record)
                        } : {
                            key: 'disable',
                            label: t('disable_transaction'),
                            icon: <FileTextOutlined />,
                            danger: true,
                            confirm: {
                                title: t('disable_transaction'),
                                content: t('are_you_sure_you_want_to_disable_this_transaction')
                            },
                            onClick: () => onAction('disable', record)
                        }
                    ] : [])
                ]}
            />
        ),
    }
];

